/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-27 11:24:44
 * @LastEditTime: 2021-01-29 14:06:37
 */
// ====ams AMS 活动相关(包括发起submit，init等)
import loader from './loader';
import { extend, isFunction } from './base';
var ams = {
  modules: {},
  // 缓存模块,白模板代码中初始化的时候传入，比如:import {bindArea,lottery_getGiftMain,checkin} from 'ams'; milo.ams.setModules({bindArea,lottery_getGiftMain,checkin})
  activitys: {},
  // 活动配置
  flows: {},
  // 流程配置，以及流程对应的缓存
  commConfig: {},
  // 通用配置，通过setCommConfig设置
  amsConfigCb: {},
  isConfigLoading: {},
  // 获取某个活动对应的配置信息，存放到activitys中
  getActivity: function getActivity(iActivity, callback) {
    var self = this; // 缓存中有

    if (self.activitys[iActivity]) {
      isFunction(callback) && callback(self.activitys[iActivity]);
      return true;
    }
    /* ========AMS活动配置文件路径优化改造 Start==========*/


    var sActId = "".concat(iActivity);
    var actDescUrl = "".concat(location.protocol, "//").concat(window.location.host, "/comm-htdocs/js/ams/actDesc/").concat(sActId.substr(sActId.length - 3), "/").concat(sActId, "/act.desc.js");

    if (!self.amsConfigCb[sActId]) {
      self.amsConfigCb[sActId] = [];
    }

    self.amsConfigCb[sActId].push(callback);

    if (self.isConfigLoading[sActId]) {
      return;
    }

    self.isConfigLoading[sActId] = true;
    /* ========AMS活动配置文件路径优化改造 End==========*/

    loader.loadScript({
      timeout: 30000,
      url: actDescUrl
    }).then(function (loaded) {
      self.isConfigLoading[sActId] = false;

      if (!loaded) {
        while (self.amsConfigCb[sActId] && self.amsConfigCb[sActId].length) {
          var _callback = self.amsConfigCb[sActId].pop();

          isFunction(_callback) && _callback(null);
        }

        return false;
      } // 存储到缓存


      self.activitys[sActId] = window["ams_actdesc_".concat(iActivity)];

      while (self.amsConfigCb[sActId] && self.amsConfigCb[sActId].length) {
        var _callback2 = self.amsConfigCb[sActId].pop();

        isFunction(_callback2) && _callback2(self.activitys[sActId]);
      }

      return true;
    })["catch"](function (err) {
      console.log('ams活动配置拉取失败', err);
      self.isConfigLoading[sActId] = false;

      while (self.amsConfigCb[sActId] && self.amsConfigCb[sActId].length) {
        var _callback3 = self.amsConfigCb[sActId].pop();

        isFunction(_callback3) && _callback3(null);
      }
    });
  },
  // 获取某个流程对应的配置信息，存放到flows中
  getFlow: function getFlow(iActivity, iFllowId, callback) {
    var self = this;

    if (self.flows[iFllowId]) {
      isFunction(callback) && callback(self.flows[iFllowId]);
    } else {
      self.getActivity(iActivity, function (res) {
        if (res) {
          var flows = res.flows;

          if (flows["f_".concat(iFllowId)]) {
            isFunction(callback) && callback({
              flow: flows["f_".concat(iFllowId)]
            });
          } else {
            callback({});
          }
        } else {
          callback({});
        }
      });
    }
  },
  // 设置模块，对应module属性
  setModules: function setModules(oModule) {
    var self = this;

    for (var modName in oModule) {
      self.modules[modName] = oModule[modName];
    }
  },
  // 获取流程对应的模块
  getModule: function getModule(modName) {
    var self = this; // 白模板中对应的老的key和新版Milo模块名的映射关系，大部分都一致

    var moduleMap = {
      'ams.bindArea_v2.bindAreaCommit': 'ams_bindArea'
    };

    if (moduleMap[modName]) {
      return self.modules[moduleMap[modName]] || null;
    } // 正常的


    var newModName = modName.replace(/\./g, '_');
    return self.modules[newModName] || null;
  },
  // 设置通用流程配置
  setCommConfig: function setCommConfig(config) {
    extend(this.commConfig, config);
  },
  // 同老板的amsInit(xxx,xxx)
  amsInit: function amsInit(iActivity, iFlowId) {
    var flowConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var self = this;
    return new Promise(function (resolve, reject) {
      self.getFlow(iActivity, iFlowId, function (_ref) {
        var flow = _ref.flow;

        if (!flow) {
          reject({
            errMsg: '活动或流程不存在，请检查活动配置'
          }); // alert(`活动:${iActivity}下流程:${iFllowId}不存在，请检查活动配置`);
        } else {
          var config = {};
          config.iAMSActivityId = iActivity;
          config.iActivityId = iActivity;
          config.iFlowId = iFlowId;
          extend(config, self.commConfig);
          extend(config, flowConfig);
          resolve({
            config: config,
            flow: flow
          }); // }
        }
      });
    });
  }
};
export default ams;